import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Layout, Button, Modal } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { ImageUrl } from "../../helpers/Functions";
import "./b2b-training.css";

function Homepage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [modal2Open, setModal2Open] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (modal2Open && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Autoplay failed:", error);
      });
    }
  }, [modal2Open]);

  React.useEffect(() => {
    if (!user && !token) {
      navigate("/", { replace: true });
    }
  }, [user, token, navigate]);

  const data1 = [
    { title: "Train customers at their own pace." },
    { title: "Help customers succeed and earn their trust." },
    { title: "Increase customer retention." },
  ];

  const data2 = [
    {
      title: "Interactive courses made of video, pdf, SCORM, HTML, and more.",
    },
    {
      title:
        "Single Sign-On for customers to log in using company credentials.",
    },
  ];

  const data3 = [
    { title: "Review Customer Performances" },
    { title: "Review Customer Feedback And Identify Skills Gaps" },
    { title: "Encourage Improvement With Engaging Activities" },
  ];

  const data4 = [
    {
      title: "Sell Course Licenses In Bulk",
      des: "and charge organizations with a one-time payment or a subscription model.",
    },
    {
      title: "Offer Discounts Using Coupon Codes",
      des: "Number of active Users, Enrollment date, Last-active date.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Childcare Center Management & Custodial Staff Training in NYC
        </title>
        <meta
          name="description"
          content="Strengthen your center with childcare management training, custodial staff training programs, and expert support for educational facilities in New York City."
        />
        <meta
          property="og:title"
          content="Childcare Center Management & Custodial Staff Training in NYC"
        />
        <meta
          property="og:description"
          content="Strengthen your center with childcare management training, custodial staff training programs, and expert support for educational facilities in New York City."
        />
      </Helmet>

      <Layout className="b2b-page">
        <section
          className="b2b-hero"
          style={{ backgroundImage: `url(${ImageUrl("new-56.png")})` }}
        >
          <div className="b2b-hero-overlay" aria-hidden />
          <div className="b2b-wrap b2b-hero-inner">
            <div className="b2b-hero-copy">
              <span className="b2b-hero-badge">LMS FOR CUSTOMER TRAINING</span>
              <h1 className="fontFamily1 b2b-hero-title">
                Boost Customer Satisfaction & <span>Loyalty</span>
              </h1>
              <p className="fontFamily1 b2b-hero-sub">
                Train your customers to become experts with your products, using
                customer training software. See how WrightCo Acadmey helps you
                create and manage training that is effective for customers and
                efficient for your organization.
              </p>
              <div className="b2b-hero-actions">
                {!token && (
                  <Button
                    type="primary"
                    className="b2b-hero-btn-primary"
                    onClick={() => navigate("/signup")}
                  >
                    Register Now
                  </Button>
                )}
                <Button
                  className="b2b-hero-btn-outline"
                  onClick={() => setModal2Open(true)}
                >
                  See The Platform <FaArrowRight />
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--muted">
          <div className="b2b-wrap">
            <div className="b2b-split">
              <div className="b2b-split-media">
                <img src={ImageUrl("new-57.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-split-copy">
                <img
                  src={ImageUrl("miniImg4.png")}
                  alt=""
                  className="b2b-section-kicker"
                />
                <h2 className="fontFamily1">Maximize Customer Retention</h2>
                <p>
                  Increase customer satisfaction by showing customers how to use
                  your product and succeed. Customer training created & managed
                  with WrightCo Academy helps you stand out from the competition.
                </p>
                <ul className="b2b-check-list">
                  {data1.map((item) => (
                    <li key={item.title}>
                      <FaCheckCircle aria-hidden />
                      <span>{item.title}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  className="b2b-btn-ghost"
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--white">
          <div className="b2b-wrap">
            <div className="b2b-split">
              <div className="b2b-split-copy">
                <img
                  src={ImageUrl("miniImg2.png")}
                  alt=""
                  className="b2b-section-kicker"
                />
                <h2 className="fontFamily1">Train Customers On Their Time</h2>
                <p>
                  Increase the value customers get from your products, using
                  online courses that customers can go through in their own time
                  from anywhere in the world.
                </p>
                <ul className="b2b-check-list">
                  {data2.map((item) => (
                    <li key={item.title}>
                      <FaCheckCircle aria-hidden />
                      <span>{item.title}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  className="b2b-btn-ghost"
                  onClick={() => navigate("/pricingPlans")}
                >
                  See Pricing
                </Button>
              </div>
              <div className="b2b-split-media">
                <img src={ImageUrl("new-58.png")} alt="" loading="lazy" />
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--navy">
          <div className="b2b-wrap">
            <div className="b2b-section-intro">
              <span className="b2b-section-kicker">
                <img src={ImageUrl("miniImg2.png")} alt="" />
              </span>
              <h2 className="fontFamily1 b2b-section-title">
                Strengthen Customer Relationships Online
              </h2>
              <p className="fontFamily1 b2b-section-lead">
                Since WrighCo.Academy keeps track of all user activity on the
                platform, you can quickly address skills gaps that customers can
                improve upon during training.
              </p>
              {!token && (
                <div className="b2b-cta-center">
                  <Button
                    className="b2b-btn-light"
                    onClick={() => navigate("/signup")}
                  >
                    Get Started
                  </Button>
                </div>
              )}
            </div>

            <div className="b2b-split">
              <div className="b2b-split-media">
                <img src={ImageUrl("new-59.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-split-copy">
                <ul className="b2b-feature-list">
                  {data3.map((item) => (
                    <li key={item.title}>
                      <span className="b2b-feature-icon" aria-hidden>
                        <FaCheckCircle />
                      </span>
                      <div>
                        <h4>{item.title}</h4>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--muted">
          <div className="b2b-wrap">
            <div className="b2b-section-intro">
              <span className="b2b-section-kicker">
                <img src={ImageUrl("miniImg4.png")} alt="" />
              </span>
              <h2 className="fontFamily1 b2b-section-title">
                Standardize Training For Global Companies
              </h2>
            </div>

            <div className="b2b-cards">
              <article className="b2b-card">
                <div className="b2b-card-media">
                  <img src={ImageUrl("new-34.png")} alt="" loading="lazy" />
                </div>
                <div className="b2b-card-body">
                  <h3>Webinars & Seminars</h3>
                  <p>
                    Create multiple-choice, short answer, and other style quizzes
                    that can be static or dynamic.
                  </p>
                </div>
              </article>
              <article className="b2b-card">
                <div className="b2b-card-media">
                  <img src={ImageUrl("new-35.png")} alt="" loading="lazy" />
                </div>
                <div className="b2b-card-body">
                  <h3>On-Demand Courses</h3>
                  <p>
                    Have learners read slides, answer questions, and participate
                    in different interactive assignments.
                  </p>
                </div>
              </article>
              <article className="b2b-card">
                <div className="b2b-card-media">
                  <img src={ImageUrl("new-36.png")} alt="" loading="lazy" />
                </div>
                <div className="b2b-card-body">
                  <h3>Translate WrighCo Academy</h3>
                  <p>
                    Start a discussion for learners in a classroom to answer
                    questions individually and work together.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="b2b-section b2b-section--navy">
          <div className="b2b-wrap">
            <div className="b2b-section-intro">
              <span className="b2b-section-kicker">
                <img src={ImageUrl("miniImg2.png")} alt="" />
              </span>
              <h2 className="fontFamily1 b2b-section-title">
                Sell Training Directly On The LMS
              </h2>
              <p className="fontFamily1 b2b-section-lead">
                Fully customize the menus, buttons, and text sections in the LMS
                to better represent your company and training type.
              </p>
              {!token && (
                <div className="b2b-cta-center">
                  <Button
                    className="b2b-btn-light"
                    onClick={() => navigate("/signup")}
                  >
                    Get Started
                  </Button>
                </div>
              )}
            </div>

            <div className="b2b-split">
              <div className="b2b-split-media">
                <img src={ImageUrl("new-28.png")} alt="" loading="lazy" />
              </div>
              <div className="b2b-split-copy">
                <ul className="b2b-feature-list">
                  {data4.map((item) => (
                    <li key={item.title}>
                      <span className="b2b-feature-icon" aria-hidden>
                        <FaCheckCircle />
                      </span>
                      <div>
                        <h4>{item.title}</h4>
                        <p>{item.des}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="b2b-trainer">
          <div className="b2b-wrap">
            <div className="b2b-trainer-card">
              <h3>We&apos;re Looking for Trainers</h3>
              <h3>Teach. Create. Earn.</h3>
              <p>
                Are you passionate about teaching? Ready to share your expertise,
                connect with professionals, and make a meaningful impact, all
                while earning extra income?
              </p>

              <h4>You&apos;ve come to the right place.</h4>
              <p>
                At WrightCo Academy, we are building a network of world-class
                trainers and industry experts dedicated to developing
                high-quality courseware for professionals in early care and
                education. If you&apos;re an expert in your field with a desire
                to teach, we&apos;d love to have you on board!
              </p>

              <h3>Why Join Us?</h3>
              <ul>
                <li>
                  <p>
                    ✅ Expand Your Reach – Share your knowledge with a broad
                    audience of professionals.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Boost Your Visibility – Gain recognition as a trusted
                    expert in your industry.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Join a Thriving Community – Connect with like-minded
                    trainers and industry leaders.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Earn Passive Income – Our fair and flexible revenue-sharing
                    model ensures unlimited earning potential.
                  </p>
                </li>
              </ul>

              <h3>What It Takes to Be a WrightCo Trainer</h3>
              <ul>
                <li>
                  <p>
                    ✔ <strong>Passion for Teaching</strong> – A commitment to
                    sharing knowledge and empowering others.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Industry Expertise</strong> – Relevant
                    certifications and experience in your domain.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Strong Communication Skills</strong> – Ability to
                    present information effectively.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Commitment to Excellence</strong> – Willingness to
                    develop and deliver high-quality training.
                  </p>
                </li>
              </ul>
              <h4>Ready to Make an Impact?</h4>
              <p>
                Join WrightCo Academy today and take the next step in your
                teaching journey.
              </p>
            </div>
          </div>
        </section>

        <Modal
          className="b2b-video-modal"
          centered
          open={modal2Open}
          onOk={() => setModal2Open(false)}
          onCancel={() => setModal2Open(false)}
          width={1000}
          footer={false}
        >
          <div style={{ padding: "24px 12px" }}>
            <video width="auto" height="auto" ref={videoRef} controls>
              <source src="https://react.customdev.solutions:3012/Uploads/tutorVideo.mp4" />
              <source src="movie.ogg" type="video/ogg" />
            </video>
          </div>
        </Modal>
      </Layout>
    </>
  );
}

export default Homepage;
